import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/layout/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/layout/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/portfolio/PortfolioContent.tsx");
